import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerComponent } from './datepicker.component';
/**
 * NgModule definition for the DatePicker component.
 */
export class DatePickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DatePickerComponent
    ],
    exports: [
        DatePickerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatePickerModule_tsickle_Closure_declarations() {
/** @type {?} */
DatePickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatePickerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
